// extracted by mini-css-extract-plugin
export default {"main":"FAQItem_main__XEsE+","question":"FAQItem_question__Dfn7F","answer":"FAQItem_answer__u2xIl"};